<template>
  <section>
    <box-default>
      <waiting-list :loading-content="loading">

        <mini-card-details :title="'Relatórios BI'"
                           resume-link="https://docs.google.com/spreadsheets/d/1WCWYvQNDNMm51P1NQ_k6VuhJ4Nhi0N8h-kzkHSewa_4/edit?usp=sharing"
                           resume-title-link="Acessar" :col="showCards ? 2 : 4" resume-target="_blank"/>
        <mini-card-details v-if="showCards" :title="'MRR'" :col="2" :resume-title="'R$' + dataDash.mrrOverall || '0'"/>

        <mini-card-details v-if="showCards" :title="'Receita Prevista'" :resumeTitle="'R$' + dataDash.mrrMonthly || '0'"
                           :col="2"/>

        <mini-card-details v-if="showCards" :title="'Valor Inadimplente'"
                           :resumeTitle="'R$' + dataDash.defaultValue || '0'" :col="2"/>

        <mini-card-details v-if="showCards" :title="'Total de Clientes Ativos'"
                           :resumeTitle="dataDash.totalActiveClients || '0'"
                           :col="2"/>

        <mini-card-details v-if="showCards" :title="'Total de Clientes Inadimplente'"
                           :resumeTitle="dataDash.totalDefault || '0'"
                           :col="2"/>

        <mini-card-details v-if="showCards" :title="'Total Planos Mensais'" :resumeTitle="dataDash.totalMonthly || '0'"
                           :col="2"/>

        <mini-card-details v-if="showCards" :title="'Total Planos Semestrais'"
                           :resumeTitle="dataDash.totalSemiannual || '0'" :col="2"/>

        <mini-card-details v-if="showCards" :title="'Total Planos Anuais'" :resumeTitle="dataDash.totalYearly || '0'"
                           :col="2"/>

        <mini-card-details v-if="showCards" :title="'Total de Planos que venceram esse mês'"
                           :resumeTitle="dataDash.totalToBeExpiredThisMonth || '0'" :col="2"/>

        <mini-card-details v-if="showCards" :title="'Assinaturas Vencidas'" :resumeTitle="dataDash.totalExpired || '0'"
                           :col="2"/>

        <mini-card-details v-if="showCards" :title="'Total de assinaturas gerando'"
                           :resumeTitle="dataDash.totalGeneratingInvoice || '0'"
                           :col="2"/>

        <mini-card-details v-if="showCards" :title="'Total de notas geradas nos ultimos 30 dias'"
                           :resumeTitle="dataDash.totalInvoiceGeneratedLast30Days || '0'" :col="2"/>

        <mini-card-details v-if="showCards" :title="'Faturamento dos ultimos 30 dias'"
                           :resumeTitle="dataDash.invoicePaidLast30Days || '0'"
                           :col="2"/>

        <mini-card-details v-if="showCards" :title="'Valor de notas geradas nos ultimos 30 dias'"
                           :resumeTitle="dataDash.invoiceValueLast30Days || '0'" :col="2"/>

        <mini-card-details v-if="showCards" :title="'LT'" :resumeTitle="dataDash.lt || '0'" :col="2"/>

        <mini-card-details v-if="showCards" :title="'Valor de upsell nos ultimos 30 dias'"
                           :resumeTitle="dataDash.upsellLast30Days || '0'"
                           :col="2"/>

        <!-- Table -->
        <box-listing v-if="showCards" :title="'Quantidade total (' + dataCompanies.length + ')'"
                     :empty-state="!dataCompanies.length"
                     :columns-list-header="tableContent.tableHeader" have-excel="true"
                     @emit-excel="downloadActualListExcel">
          <template>
            <tr v-for="(a, index) in dataCompanies" :key="index" class="table-tr">
              <td>
                <a v-bind:href="'/detalhes-da-empresa/' + a.id + '/' + a.contextCode" target="_blank"
                   class="link">{{ a.name }}</a>
              </td>
              <td>{{ a.email }}</td>
              <td>{{ a.maxTotalEmployeeInContract }}</td>
              <td>{{ a.planType }}</td>
              <td>R{{ a.price | currency }}</td>
              <td>R{{ a.mrr | currency }}</td>
              <td>{{ a.contractValidUntil | formatDate }}</td>
            </tr>
          </template>
        </box-listing>

      </waiting-list>
    </box-default>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import {
  GET_MASTER_DASH
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL,
  UTIL_SERVICE
} from "../../../../utils";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";
import BoxDefault from "../../components/layouts/boxDefault.vue";
import WaitingList from "../../components/layouts/waitingList.vue";
import MiniCardDetails from "../../components/layouts/miniCardDetails.vue";
import BoxListing from "../../components/layouts/boxListing.vue";

export default {
  name: "dashboard",
  components: {
    BoxListing,
    MiniCardDetails,
    WaitingList,
    BoxDefault,
    topMenu,
    fullLoading
  },
  data() {
    return {
      loading: false,
      showCards: false,
      dataDash: {},
      dataCompanies: [],
      browserId: "",
      orderByValue: "name",
      tableContent: {
        tableHeader: [
          'Empresa',
          'E-mail',
          'Total de funcionários',
          'Plano',
          'MRR',
          'Contrato válido até',
        ]
      },
    }
  },
  methods: {
    downloadActualListExcel() {
      let bodyValue = [];
      this.dataCompanies.map((value, index) => {
        bodyValue.push([value.name, value.email, value.maxTotalEmployeeInContract, value.planType, value.price, value.mrr, value.contractValidUntil]);

        if (index + 1 === this.dataCompanies.length) {
          let headValue = ["EMPRESA", "E-MAIL", "QTD TOTAL DE FUNCIONÁRIO", "PLANO", "PREÇO", "MRR", "CONTRATO VÁLIDO ATÉ"];

          window.downloadListExcel(headValue, bodyValue, "Relatório");
        }
      });
    },
    getMasterDash() {
      if (UTIL.checkP(JSON.parse(window.localStorage.getItem('mamUserMasterInfo')).id)) {
        this.loading = true;
        this.showCards = true;
        REQUEST_SERVICE.get(GET_MASTER_DASH).then((response) => {
          UTIL_SERVICE.console("RESULT GET_MASTER_DASH:", response.data);

          if (response.data) {
            this.dataDash = response.data;
            this.dataCompanies = [];

            if (response.data.companies) {
              this.dataCompanies = response.data.companies;
            }
          }

          this.loading = false;
        }).catch((reason) => {
          this.loading = false;

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      }
    },
  },
  beforeMount() {
    if (this.browserId === null || !this.browserId) {
      this.browserId = UTIL_SERVICE.randomToken();

      window.localStorage.setItem('browserId', JSON.stringify(this.browserId));
    }
  },
  mounted() {
    this.getMasterDash();
  }
}
</script>

<style lang="scss" scoped>
.card {
  background: #FFFFFF;
  border-radius: 4px !important;
  margin-bottom: 20px;
  text-align: center;
  min-height: 130px;
  -ms-flex-align: center !important;
  align-items: center !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .16), 0 0 0 1px rgba(0, 0, 0, .08);

  p {
    display: block;
    margin: 0 0 10px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
  }

  small {
    display: block;
    font-size: 28px;
    font-weight: 500;
  }
}

.right {
  float: right;
}

.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00A651;
  color: #FFF;
  margin-bottom: 20px;
  border-radius: 4px !important;
  margin-top: 0;
  border: none;
  font-weight: 700;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #FFF;
    background-color: #008D45;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/dashboard/dashboard.vue